module.exports = __webpack_public_path__ + "static/bloomberg-2875de7350cafe6ff3ec61917d0b216b.png";